import type { ReactElement } from 'react';
import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RHFTextFieldWithAdornment, type RHFTextFieldWithAdornmentProps } from '../TextField/RHFTextFieldWithAdornment';

export type RHFPercentFieldProps<T extends FieldValues = Record<string, string>> = Omit<
  RHFTextFieldWithAdornmentProps<T>,
  'startAdornment' | 'endAdornment'
>;

export const RHFPercentField = <T extends FieldValues = Record<string, string>>(
  props: RHFPercentFieldProps<T>
): ReactElement => {
  const { t } = useTranslation();

  return (
    <RHFTextFieldWithAdornment<T>
      formControlProps={{ margin: 'dense' }}
      placeholder={t('Enter Value')}
      {...props}
      endAdornment="%"
    />
  );
};
